const translation = {
  Product: "Prodotto",
  "Header.productNav": "Prodotto LUKKEY",
  Feature: "Caratteristica",
  "About Us": "Chi siamo",
  FAQ: "FAQ",
  "Privacy Policy": "Politica sulla privacy",
  "Help Center": "Centro assistenza",
  "Header.infoMenu": "Altro",
  "Header.appNow": "Ottieni l’app",
  "Header.appModal.title": "Usa subito l’app LUKKEY",
  "Header.appModal.subtitle": "Scegli la tua piattaforma per ottenere l’app mobile ufficiale di LUKKEY.",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "Installa l’app ufficiale su iPhone.",
  "Header.appModal.iosButton": "Apri",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Ottieni l’app Android ufficiale su Google Play.",
  "Header.appModal.googlePlayButton": "Apri",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "Scarica direttamente l’ultima APK ufficiale.",
  "Header.appModal.androidButton": "Scarica",
  "Header.appModal.note": "Solo download mobili ufficiali. Usa i link qui sopra per ottenere l’ultima versione.",
  "Academy": "Accademia",
  "Legal": "Legale",
  "AboutUs.title": "Informazioni su LUKKEY",
  "AboutUs.lede": "LUKKEY è un marchio svizzero di hardware wallet dedicato a costruire il più alto standard di sicurezza per la proprietà di asset digitali.",
  "AboutUs.vision.closing": "Le tue chiavi. I tuoi asset. Il tuo futuro.",
  "AboutUs.quote": "LUKKEY costruisce il livello di sicurezza tra le persone e gli asset digitali.",
  "AboutUs.block1": "LUKKEY ha sede in Svizzera. Si concentra su hardware wallet progettati per una self-custody sicura.",
  "AboutUs.block2": "I suoi prodotti combinano secure element, protezione anti-manomissione e un'architettura completamente offline. L'obiettivo è mantenere le chiavi private in un ambiente isolato.",
  "AboutUs.block3": "Il sistema è progettato senza Wi‑Fi, USB o dipendenza diretta dalla rete. Accesso con impronta, strumenti di backup NFC e ampio supporto agli asset lo rendono pratico nell'uso quotidiano.",
  "AboutUs.block5": "LUKKEY segue un approccio aperto e verificabile per firmware e software core. Le affermazioni sulla sicurezza devono poter essere ispezionate e verificate.",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "Richiesta di supporto",
  "WarrantySupport.intro": "Compila le informazioni qui sotto per inviare la tua richiesta di supporto.",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "Riepilogo del problema",
  "WarrantySupport.form.issueTitle.placeholder": "Inserisci un breve riepilogo",
  "WarrantySupport.form.warrantyType.label": "Tipo di richiesta",
  "WarrantySupport.form.warrantyType.placeholder": "Seleziona il tipo di richiesta",
  "WarrantySupport.form.warrantyType.product": "Problema del dispositivo",
  "WarrantySupport.form.warrantyType.service": "Problema app/account",
  "WarrantySupport.form.warrantyType.replacement": "Altro",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "Descrivi il problema o la richiesta in dettaglio",
  "WarrantySupport.form.submit": "Invia richiesta di supporto",
  "WarrantySupport.alert.success": "La tua richiesta di supporto è stata inviata!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "Centro assistenza",
  "HelpCenter.intro":
    "Benvenuto nel Centro Assistenza LUKKEY! Se sei nuovo alle criptovalute o hai bisogno di aiuto con il tuo cold wallet, sei nel posto giusto. La nostra soluzione di cold wallet offre il modo più sicuro per conservare e gestire i tuoi asset digitali. Di seguito troverai risposte ad alcune delle domande più comuni e suggerimenti di risoluzione dei problemi.",
  "HelpCenter.section4.title": "Hai bisogno di ulteriore supporto?",
  "HelpCenter.section4.intro":
    "Risparmia tempo avviando la tua richiesta di supporto online e ti metteremo in contatto con uno specialista. Per la tua sicurezza, il supporto ufficiale non chiederà mai la tua frase di recupero o la tua chiave privata:",
  "HelpCenter.contact.hint": "Usa il pulsante per inviare una richiesta di supporto e ti contatteremo via email.",
  "HelpCenter.cta.warranty": "Invia richiesta di supporto",
  brandName: "LUKKEY",
  tagline: "Gestisci la tua criptovaluta come mai prima d'ora",
  description:
    "Inizia il tuo viaggio verso la libertà finanziaria con la nostra app. Proteggi i tuoi asset con la nostra tecnologia avanzata di portafoglio freddo e gestisci le tue finanze in modo più intelligente ed efficace. Il tuo benessere finanziario è la nostra priorità.",
  "home.seoTitle": "LUKKEY | Hardware wallet svizzero per self-custody sicura",
  "home.seoDescription": "LUKKEY è un brand svizzero di hardware wallet focalizzato su sicurezza cold wallet, protezione offline delle chiavi private, accesso con impronta digitale e backup NFC per una self-custody sicura.",
  learnMore: "Scopri di più",
  "Lock Your Crypto, Securely": "Blocca la tua criptovaluta in modo sicuro",
  Testimonials: "Testimonianze",
  Testimonial1:
    "Sto usando questo portafoglio freddo da mesi e sono impressionato dalla sua affidabilità e dalle funzionalità di sicurezza. Altamente consigliato!",
  Testimonial2:
    "Questo portafoglio freddo ha superato le mie aspettative! La sua interfaccia user-friendly e la sicurezza di alto livello lo rendono uno strumento imprescindibile per chiunque prenda sul serio le criptovalute.",
  Testimonial3:
    "Ho provato diversi portafogli freddi prima, ma questo si distingue. Il suo design elegante e le funzionalità avanzate rendono facile la gestione dei miei asset crypto.",
  "John Doe": "John Doe",
  "Cryptocurrency Enthusiast": "Appassionato di criptovalute",
  "Jane Smith": "Jane Smith",
  "Crypto Security Advocate": "Difensore della sicurezza delle criptovalute",
  "Alex Johnson": "Alex Johnson",
  "Investment Analyst": "Analista finanziario",
  "Touchscreen Interface": "Interfaccia a schermo tattile",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "Sperimenta la gestione delle criptovalute senza sforzo con la nostra interfaccia a schermo tattile intuitiva, progettata per una navigazione rapida e semplice dei tuoi asset digitali, consentendo transazioni rapide e una gestione sicura a portata di mano.",
  "Bluetooth Connectivity": "Connettività Bluetooth",
  "Wireless syncing with your devices for real-time updates.":
    "Sincronizzazione wireless con i tuoi dispositivi per aggiornamenti in tempo reale.",
  "Airtag Tracking": "Tracciamento Airtag",
  "Track your wallet easily with built-in Airtag.":
    "Traccia facilmente il tuo portafoglio con l'Airtag integrato.",
  "Secure Chip Technology": "Tecnologia del chip sicuro",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "Dotato di un chip di sicurezza avanzato, garantendo una protezione robusta per i tuoi preziosi asset digitali contro accessi non autorizzati e minacce informatiche.",
  "Cross-Platform Support": "Supporto multipiattaforma",
  "Works with various platforms for easy accessibility.":
    "Funziona con diverse piattaforme per una facile accessibilità.",
  AboutUsDescription1:
    "In LUKKEY, siamo dedicati a fornire soluzioni di alta qualità per la gestione sicura dei tuoi asset in criptovalute.",
  AboutUsDescription2:
    "La nostra sede si trova a Zug, in Svizzera. Con un team di professionisti esperti, ci impegniamo a innovare e ad adattarci al mercato in continua evoluzione delle valute digitali.",
  BlockchainNetworksSupported: "Reti Blockchain supportate",
  CryptocurrenciesSupported: "Supporto per oltre 6.000 criptovalute",
  Years: "Anni",
  ExpertiseInSecurity: "di esperienza nella sicurezza",
  FrequentlyAskedQuestions: "Domande frequenti",
  WhatIsColdWallet: "Che cos'è un Cold Wallet?",
  ColdWalletDescription:
    "Un cold wallet è un tipo di portafoglio di criptovalute che memorizza i tuoi asset digitali offline, rendendoli meno vulnerabili agli attacchi e ad altre minacce online. A differenza dei portafogli caldi, che sono connessi a Internet e comodi per le transazioni frequenti, i cold wallet sono più adatti per lo stoccaggio a lungo termine poiché offrono una sicurezza maggiore.",
  HowToSetUpColdWallet: "Come configurare il tuo Cold Wallet?",
  ColdWalletSetupDescription:
    "Impostare il tuo cold wallet normalmente implica l'inizializzazione del dispositivo su una macchina sicura e offline. Dovrai generare e memorizzare in modo sicuro una frase di recupero, che è essenziale per accedere ai tuoi asset in caso di perdita o guasto del dispositivo. Le istruzioni dettagliate vengono fornite con l'acquisto, assicurando un processo di configurazione senza problemi.",
  CryptocurrenciesCompatibleWithColdWallet:
    "Quali criptovalute sono compatibili con i tuoi cold wallet?",
  CryptocurrenciesCompatibilityDescription:
    "I nostri cold wallet supportano una vasta gamma di criptovalute, comprese le principali come Bitcoin, Ethereum e Litecoin, oltre a numerose altcoin. Per un elenco completo delle criptovalute supportate, visita il nostro sito web o consulta la documentazione del prodotto.",
  HowToSecureColdWallet: "Come garantire che il mio cold wallet sia sicuro?",
  ColdWalletSecurityDescription:
    "Per proteggere il tuo cold wallet, conserva sempre la frase di recupero in un luogo sicuro e privato, non condividerla mai con nessuno e considera l'uso di misure di sicurezza aggiuntive come blocchi biometrici o contenitori sicuri. Aggiornare regolarmente il firmware del portafoglio dal sito ufficiale aiuta anche a proteggere contro le vulnerabilità.",
  ColdWalletNotWorking:
    "Cosa fare se il mio cold wallet non funziona o se incontro un errore?",
  ColdWalletErrorDescription:
    "Se riscontri problemi con il tuo cold wallet, consulta la sezione di risoluzione dei problemi nel nostro manuale utente. Per problemi più specifici, contatta il nostro team di supporto tramite il nostro sito web. Assicurati di avere a portata di mano le informazioni sul dispositivo per accelerare il processo di supporto.",
  Community: "Comunità",
  "Join our community on your favorite platform to stay up-to-date, ask questions, and connect with other users.":
    "Unisciti alla nostra comunità sulla tua piattaforma preferita per rimanere aggiornato, fare domande e connetterti con altri utenti.",
  "Subscribe.title": "Ricevi aggiornamenti sul prodotto",
  "Subscribe.subtitle":
    "Seguiamo noi i trend cripto per te. Ricevi aggiornamenti di prodotto, approfondimenti di mercato e vantaggi esclusivi — direttamente nella tua casella di posta.",
  "Subscribe.placeholder": "Inserisci la tua email",
  "Subscribe.button": "Iscriviti agli aggiornamenti del prodotto",
  "Subscribe.input.aria": "Campo di inserimento indirizzo email",
  "Subscribe.success":
    "Grazie per esserti iscritto! Controlla l’email di conferma.",
  "Subscribe.error": "Iscrizione non riuscita. Riprova più tardi.",
  "Subscribe.invalid": "Inserisci un indirizzo email valido.",
  "Subscribe.privacy":
    "Il tuo indirizzo email verrà usato solo per inviare la nostra newsletter e gli aggiornamenti. Puoi annullare l’iscrizione in qualsiasi momento tramite il link presente nella newsletter.",
  "Subscribe.learnMore":
    "Scopri di più su come gestiamo i tuoi dati e i tuoi diritti.",
  "Subscribe.popupCompact.title": "Resta aggiornato",
  "Subscribe.popupCompact.subtitle":
    "Aggiornamenti sul prodotto e informazioni sulla sicurezza. Niente spam.",
  "Subscribe.popupCompact.button": "Iscriviti",
  "Subscribe.popupCompact.privacy":
    "Solo e-mail. Disiscrizione in qualsiasi momento.",
  "SubscribeConfirmed.alt.success": "Iscrizione confermata",
  "SubscribeConfirmed.alt.failed": "Iscrizione non riuscita",
  "SubscribeConfirmed.title.success": "Iscrizione confermata",
  "SubscribeConfirmed.title.failed": "Iscrizione non riuscita",
  "SubscribeConfirmed.message.success":
    "Grazie per aver confermato la tua email. La tua iscrizione è ora attiva. Un'email di benvenuto è stata inviata alla tua casella di posta.",
  "SubscribeConfirmed.message.failed":
    "Il link di conferma non è valido o è scaduto. Torna alla home page e prova a iscriverti di nuovo.",
  "SubscribeConfirmed.cta.backHome": "Torna alla home",
  "SubscribeConfirmed.note.unsubscribe":
    "Puoi annullare l’iscrizione in qualsiasi momento tramite il link presente nelle nostre email.",
  // ===== MarketView i18n =====
  "MarketView.title": "Dashboard di mercato",
  "MarketView.loading": "Caricamento...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "Questa scheda non è stata caricata",
  "MarketView.unknownError": "Errore sconosciuto",

  // ===== Common i18n =====
  "Common.refresh": "Aggiorna",
  "Common.toggleSeriesVisibility": "Attiva/disattiva questa serie",
  "Common.error": "Errore",
  "Common.dataUpdateTime": "Ora di aggiornamento dati",
  "Common.loading": "Caricamento...",
  "Common.noDataSource": "Nessun dato (sorgente non fornita)",

  // ===== Common ranges =====
  "Common.to": "a",
  "Common.clear": "Pulisci",
  "Common.range.thisMonth": "Questo mese",
  "Common.range.lastMonth": "Mese scorso",
  "Common.range.last2": "Ultimi 2 mesi",
  "Common.range.last3": "Ultimi 3 mesi",
  "Common.range.last6": "Ultimi 6 mesi",
  "Common.range.thisYear": "Quest'anno",
  "Common.range.all": "Tutti",
  "Common.range.custom": "Personalizzato",
  "Common.showFilters": "Mostra filtri",
  "Common.hideFilters": "Nascondi filtri",
  "Common.search": "Cerca",
  "Common.priority": "Priorità",
  "Common.owner": "Responsabile",
  "Common.collaborator": "Collaboratore",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "Scarica backend data/youtube_stats.json",
  "YouTubeTab.downloadJson": "Scarica youtube_stats.json",
  "YouTubeTab.loading": "Caricamento metriche YouTube...",
  "YouTubeTab.errorHint":
    "Se la chiave API non è configurata, imposta YOUTUBE_API_KEY o GOOGLE_API_KEY in backend/.env e riavvia il backend.",
  "YouTubeTab.header.totalViews":
    "Visualizzazioni totali (multi-canale, unità: 10k)",
  "YouTubeTab.header.totalSubscribers":
    "Iscritti totali (multi-canale, unità: 10k)",
  "YouTubeTab.dist.views": "Distribuzione visualizzazioni (10k)",
  "YouTubeTab.dist.subscribers": "Distribuzione iscritti (10k)",
  "YouTubeTab.card.location": "Località:",
  "YouTubeTab.card.registeredAt": "Registrato il:",
  "YouTubeTab.card.currentSubscribers": "Iscritti attuali",
  "YouTubeTab.card.currentVideos": "Numero video attuali",
  "YouTubeTab.card.currentTotalViews": "Visualizzazioni totali attuali",
  "YouTubeTab.card.currentTotalComments": "Commenti totali attuali",
  "YouTubeTab.chart.totalSubscribers": "Iscritti totali",
  "YouTubeTab.chart.totalViews": "Visualizzazioni totali",
  "YouTubeTab.chart.totalComments": "Commenti totali",
  "YouTubeTab.chart.totalVideos": "Video totali",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "Scarica backend data/x_stats.json",
  "XTab.downloadJson": "Scarica x_stats.json",
  "XTab.loading": "Caricamento metriche X...",
  "XTab.errorHint":
    "Se il token non è configurato, imposta X_BEARER_TOKEN o TWITTER_BEARER_TOKEN in backend/.env e riavvia il backend.",
  "XTab.header.totalFollowers": "Follower totali (multi-canale, unità: 10k)",
  "XTab.header.totalEngagement":
    "Coinvolgimento totale (ultimi 5 post: Mi piace + Retweet + Risposte + Citazioni, unità: 10k)",
  "XTab.dist.followers": "Distribuzione follower (10k)",
  "XTab.dist.engagement":
    "Distribuzione coinvolgimento (ultimi 5 post: Mi piace + Retweet + Risposte + Citazioni, unità: 10k)",
  "XTab.card.currentFollowers": "Follower attuali",
  "XTab.card.currentFollowing": "Seguiti attuali",
  "XTab.card.currentTweets": "Numero di tweet attuali",
  "XTab.card.recentLikes": "Mi piace recenti (ultimi 5 post)",
  "XTab.card.recentRetweets": "Retweet recenti (ultimi 5 post)",
  "XTab.card.recentReplies": "Risposte recenti (ultimi 5 post)",
  "XTab.card.recentQuotes":
    "Visualizzazioni recenti (livello contenuto, ultimi 5 post)",
  "XTab.card.listed": "Volte in liste (livello canale)",
  "XTab.smallChart.followers": "Follower",
  "XTab.smallChart.tweets": "Tweet",
  "XTab.smallChart.likes": "Mi piace recenti",
  "XTab.smallChart.retweets": "Retweet recenti",
  "XTab.smallChart.replies": "Risposte recenti",
  "XTab.smallChart.quotes": "Visualizzazioni recenti (livello contenuto)",
  "XTab.smallChart.following": "Seguiti",
  "XTab.smallChart.listed": "Elencati",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "Filtra per mese di creazione:",
  "Analytics.dashboardTitle": "Dashboard salute progetto",
  "Analytics.metric.completionRate": "Tasso di completamento",
  "Analytics.metric.teamVelocity": "Velocità del team",
  "Analytics.metric.blockerRatio": "Rapporto blocchi",
  "Analytics.metric.workloadBalance": "Bilanciamento carico di lavoro",
  "Analytics.charts.statusDistribution": "Distribuzione stati",
  "Analytics.charts.statusByMonthPercent": "Stati per mese (percentuale)",
  "Analytics.charts.priorityDistribution": "Distribuzione priorità",
  "Analytics.charts.priorityByMonthPercent": "Priorità per mese (percentuale)",
  "Analytics.charts.functionTypeDistribution":
    "Distribuzione per tipo di funzione",
  "Analytics.charts.functionTypeByMonthPercent":
    "Tipo di funzione per mese (percentuale)",
  "Analytics.blocker.ownerPie":
    "Problemi bloccati · Distribuzione responsabili (ciambella)",
  "Analytics.blocker.ownerByMonth":
    "Problemi bloccati · Responsabili per mese (percentuale)",
  "Analytics.bug.ownerPie": "Bug · Distribuzione responsabili (ciambella)",
  "Analytics.bug.ownerByMonth": "Bug · Responsabili per mese (percentuale)",
  "Analytics.ownerWorkloadDistribution":
    "Distribuzione carico di lavoro del team",
  "Analytics.mode.priority": "Distribuzione priorità",
  "Analytics.mode.status": "Distribuzione stati",
  "Analytics.mode.type": "Distribuzione tipi",
  "Analytics.blocker.attentionNeeded":
    "Problemi che richiedono attenzione immediata",
  "Analytics.common.status": "Stato",
  "Analytics.common.owner": "Responsabile",
  "Analytics.insights.sectionTitle": "Approfondimenti e raccomandazioni",
  "Analytics.insights.efficiency.title":
    "Suggerimenti di miglioramento dell'efficienza",
  "Analytics.insights.efficiency.completionRate":
    "• Il tasso di completamento attuale è {{rate}}%, monitora i blocchi",
  "Analytics.insights.efficiency.avgVelocity":
    "• La velocità media del team è {{velocity}} attività/persona",
  "Analytics.insights.efficiency.workloadBalance":
    "• Il bilanciamento del carico è {{balance}}%",
  "Analytics.insights.risk.title": "Avvisi di rischio",
  "Analytics.insights.risk.blockerRatio": "• Rapporto blocchi {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• Rapporto problemi P0 {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• Gestisci prima i problemi ad alta priorità",

  // ===== Kanban i18n =====
  "Kanban.title": "Vista Kanban",
  "Kanban.totalIssues": "Totale {{count}} problemi",
  "Kanban.searchPlaceholder":
    "Cerca titolo, numero issue, responsabile o collaboratori...",
  "Kanban.status.backlog": "Backlog",
  "Kanban.status.inProgress": "In corso",
  "Kanban.status.blocked": "Bloccato / In attesa di conferma",
  "Kanban.status.reviewTest": "Revisione / Test",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "Elenco problemi",
  "List.totalIssues": "Totale {{count}} problemi",
  "List.viewDetails": "Vedi dettagli",
  "List.openInNewWindow": "Apri in una nuova finestra",
  "List.empty.title": "Nessun problema",
  "List.empty.subtitle":
    "Crea il primo problema per avviare il flusso di lavoro",

  // ===== Assets Register i18n =====
  "Assets.title": "Registro beni",
  "Assets.totalSets": "Set totali",
  "Assets.table.employee": "Dipendente",
  "Assets.table.setCount": "Set",
  "Assets.table.model": "Modello",
  "Assets.total": "Totale",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "Tracciamento problemi di progetto",
  "LukkeyIssues.goToDemo": "Vai alla pagina demo",
  "LukkeyIssues.githubProject": "Progetto GitHub ↗",
  "LukkeyIssues.githubManageIssues": "Gestisci Issues direttamente su GitHub ↗",
  "LukkeyIssues.financeModel": "Modello finanziario",
  "LukkeyIssues.productCoreIssues": "Problemi core del prodotto",
  "LukkeyIssues.stats.totalIssues": "📊 Problemi totali",
  "LukkeyIssues.stats.completed": "✅ Completati",
  "LukkeyIssues.stats.inProgress": "🔄 In corso",
  "LukkeyIssues.stats.pending": "⏳ In attesa",
  "LukkeyIssues.stats.blocked": "🚫 Bloccati",
  "LukkeyIssues.stats.docs": "📚 Documenti",
  "LukkeyIssues.tabs.kanban": "Vista Kanban",
  "LukkeyIssues.tabs.analytics": "Analitica",
  "LukkeyIssues.tabs.market": "Dashboard di mercato",
  "LukkeyIssues.tabs.assets": "Registro beni",
  "LukkeyIssues.shareToChatGPT": "Apri LUKKEY.json con ChatGPT", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "Informativa sulla Privacy di LUKKEY",
  "PrivacyPolicy.intro.p1":
    "In LUKKEY crediamo che la forma più sicura di privacy sia quella che rimane sempre nelle mani dell’utente.",
  "PrivacyPolicy.intro.p2":
    "Pertanto, sia che utilizzi l’hardware cold wallet LUKKEY sia l’applicazione mobile LUKKEY (App), aderiamo rigorosamente a un principio incrollabile:",
  "PrivacyPolicy.intro.p3_strong":
    "Salvo esplicita autorizzazione dell’utente, non raccogliamo, non archiviamo e non carichiamo alcuna informazione dell’utente.",
  "PrivacyPolicy.intro.p3_tail":
    "Tutti i dati relativi all’utilizzo sono archiviati esclusivamente in locale sul dispositivo dell’utente e non vengono mai trasmessi a LUKKEY o ad alcun server.",
  "PrivacyPolicy.intro.p4":
    "La presente Informativa sulla Privacy spiega come rispettiamo questo principio.",

  "PrivacyPolicy.s1.title": "1. Ambito di applicazione",
  "PrivacyPolicy.s1.appliesTo":
    "La presente Informativa sulla Privacy si applica a:",
  "PrivacyPolicy.s1.item.hardware": "Hardware cold wallet LUKKEY",
  "PrivacyPolicy.s1.item.app": "Applicazione mobile LUKKEY (App)",
  "PrivacyPolicy.s1.principle":
    "Entrambi seguono il principio unificato di “zero raccolta, zero upload, archiviazione solo locale”.",

  "PrivacyPolicy.s2.title": "2. Informazioni che NON raccogliamo",
  "PrivacyPolicy.s2.desc":
    "Per proteggere la tua privacy, ci impegniamo esplicitamente a non raccogliere, caricare o archiviare alcuna informazione dell’utente, incluse ma non limitate a:",
  "PrivacyPolicy.s2.li.identity":
    "Informazioni di identità: nome, numero di telefono, indirizzo e‑mail, indirizzo postale",
  "PrivacyPolicy.s2.li.walletSensitive":
    "Dati sensibili del wallet: chiavi private, frasi mnemoniche, file keystore, password del wallet",
  "PrivacyPolicy.s2.li.blockchain":
    "Dati blockchain: indirizzi del wallet, cronologia delle transazioni, informazioni sugli asset",
  "PrivacyPolicy.s2.li.behavior":
    "Comportamento d’uso: log dell’app, registri di clic, analisi comportamentale",
  "PrivacyPolicy.s2.li.technical":
    "Informazioni tecniche: identificatori del dispositivo, geolocalizzazione, indirizzo IP",
  "PrivacyPolicy.s2.inShort.title": "In breve:",
  "PrivacyPolicy.s2.inShort.desc":
    "Tutto ciò che vedi sul dispositivo hardware e nell’App esiste solo sul tuo dispositivo. LUKKEY non può accedervi.",

  "PrivacyPolicy.s3.title": "3. Privacy e sicurezza del cold wallet (hardware)",
  "PrivacyPolicy.s3.desc":
    "Il cold wallet LUKKEY fornisce un ambiente completamente offline e sicuro. Caratteristiche chiave:",
  "PrivacyPolicy.s3.h1.title": "1. Hardware di sicurezza di livello militare",
  "PrivacyPolicy.s3.h1.l1": "Secure Element certificato EAL6+",
  "PrivacyPolicy.s3.h1.l2":
    "Comunicazione crittografata a livello hardware su tutta la catena",
  "PrivacyPolicy.s3.h2.title": "2. Funzioni di sicurezza",
  "PrivacyPolicy.s3.h2.l1": "Autenticazione tramite impronta digitale",
  "PrivacyPolicy.s3.h2.l2": "Modalità privacy",
  "PrivacyPolicy.s3.h2.l3": "Gestione isolata di più wallet",
  "PrivacyPolicy.s3.h3.title": "3. Isolamento completo",
  "PrivacyPolicy.s3.h3.l1": "Nessuna connettività a Internet",
  "PrivacyPolicy.s3.h3.l2": "Nessuna connessione tramite cavo dati",
  "PrivacyPolicy.s3.h4.title": "4. Anti‑manomissione con autodistruzione",
  "PrivacyPolicy.s3.h4.desc":
    "Se il dispositivo viene smontato, danneggiato o subisce intrusioni anomale, il Secure Element distrugge automaticamente i dati sensibili per impedire l’estrazione delle chiavi private.",
  "PrivacyPolicy.s3.h5.title":
    "5. Operazioni sensibili solo all’interno del Secure Element",
  "PrivacyPolicy.s3.h5.l1": "Creazione del wallet",
  "PrivacyPolicy.s3.h5.l2": "Importazione del wallet",
  "PrivacyPolicy.s3.h5.l3": "Firma delle transazioni",
  "PrivacyPolicy.s3.h5.note":
    "Tutti i processi sensibili avvengono al 100% nel Secure Element e non vengono mai esposti a chip o archivi non sicuri.",
  "PrivacyPolicy.s3.h6.title":
    "6. Nessun dato sensibile al di fuori del Secure Element",
  "PrivacyPolicy.s3.h6.desc":
    "Le aree di archiviazione non sicure del dispositivo non memorizzano mai chiavi private, frasi mnemoniche o altre informazioni sensibili.",

  "PrivacyPolicy.s4.title": "4. Privacy e sicurezza dell’App LUKKEY",
  "PrivacyPolicy.s4.desc":
    "L’App LUKKEY è focalizzata esclusivamente sulla visualizzazione di informazioni e sulla fornitura di notifiche. Non gestisce dati sensibili del wallet.",
  "PrivacyPolicy.s4.n1.title": "1. Cosa l’App NON fa",
  "PrivacyPolicy.s4.n1.l1": "Non genera wallet blockchain",
  "PrivacyPolicy.s4.n1.l2": "Non importa wallet blockchain",
  "PrivacyPolicy.s4.n1.l3": "Non archivia chiavi private o frasi mnemoniche",
  "PrivacyPolicy.s4.n1.l4": "Non carica alcun dato dell’utente",
  "PrivacyPolicy.s4.n1.l5":
    "Non effettua analisi comportamentali, tracciamenti pubblicitari o raccolte di dati",
  "PrivacyPolicy.s4.n2.title": "2. Cosa l’App FA",
  "PrivacyPolicy.s4.n2.l1":
    "Mostra informazioni di pubblico accesso autorizzate dall’hardware",
  "PrivacyPolicy.s4.n2.l2":
    "Fornisce un pannello privacy che spiega lo scopo di ciascun permesso",
  "PrivacyPolicy.s4.n2.l3":
    "Dà all’utente pieno controllo per abilitare/disabilitare i permessi in qualsiasi momento",
  "PrivacyPolicy.s4.n2.l4": "Offre l’offuscamento delle informazioni sensibili",
  "PrivacyPolicy.s4.n2.l5":
    "Disabilita screenshot/registrazione in determinate viste",
  "PrivacyPolicy.s4.n2.l6":
    "Rileva indirizzi blockchain sospetti tramite riscontro locale",
  "PrivacyPolicy.s4.n2.l7":
    "Aggiorna regolarmente URL, contratti e indirizzi pericolosi",
  "PrivacyPolicy.s4.n2.l8":
    "Flusso di aggiornamento monodirezionale: solo server → dispositivo",
  "PrivacyPolicy.s4.n2.l9":
    "Durante gli aggiornamenti non vengono mai inviati dati dell’utente",
  "PrivacyPolicy.s4.n3.title": "3. Archiviazione locale",
  "PrivacyPolicy.s4.n3.p1":
    "L’App archivia localmente solo dati non privati, come preferenze UI, lingua e tema. Questi dati:",
  "PrivacyPolicy.s4.n3.l1": "non vengono caricati",
  "PrivacyPolicy.s4.n3.l2": "non vengono sincronizzati",
  "PrivacyPolicy.s4.n3.l3": "non sono accessibili a LUKKEY",

  "PrivacyPolicy.s5.title": "5. Trasmissione dei dati e policy del server",
  "PrivacyPolicy.s5.l1":
    "I server LUKKEY non memorizzano alcuna informazione dell’utente",
  "PrivacyPolicy.s5.l2":
    "La comunicazione App–server è limitata ad aggiornamenti di database e di versione",
  "PrivacyPolicy.s5.l3":
    "Durante la comunicazione non vengono trasmesse informazioni dell’utente",
  "PrivacyPolicy.s5.l4":
    "Anche in caso di violazione del server, nessun dato utente può essere esposto, poiché non otteniamo mai tali dati",

  "PrivacyPolicy.s6.title": "6. Trasparenza open‑source",
  "PrivacyPolicy.s6.l1": "Il codice sorgente dell’App LUKKEY è open‑source",
  "PrivacyPolicy.s6.l2":
    "Il firmware incorporato dell’hardware LUKKEY è open‑source",
  "PrivacyPolicy.s6.l3":
    "Completamente disponibile su GitHub per chiunque voglia esaminarlo",
  "PrivacyPolicy.s6.p": "La trasparenza è parte della sicurezza.",

  "PrivacyPolicy.s7.title": "7. Pieno controllo dell’utente",
  "PrivacyPolicy.s7.p":
    "Anche se non raccogliamo informazioni dell’utente, gli utenti mantengono il pieno controllo dei propri dispositivi:",
  "PrivacyPolicy.s7.l1":
    "Puoi disattivare i permessi dell’App in qualsiasi momento",
  "PrivacyPolicy.s7.l2":
    "Puoi disinstallare l’App per rimuovere tutti i dati locali dell’applicazione",
  "PrivacyPolicy.s7.l3":
    "Puoi reimpostare il dispositivo hardware per cancellare definitivamente chiavi private e dati del wallet",
  "PrivacyPolicy.s7.p2":
    "LUKKEY non interviene e non può intervenire in tali azioni.",

  "PrivacyPolicy.s8.title": "8. Contattaci",
  "PrivacyPolicy.s8.p":
    "Per qualsiasi domanda relativa alla presente Informativa sulla Privacy, contattaci:",
  "PrivacyPolicy.s8.email": "E‑mail: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "Indirizzo: Sede LUKKEY, Baarerstrasse 25, 6300 Zug, Svizzera",

  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "Verifica in corso...",
  "EmailOtp.title":
    "Accesso limitato: inserisci nome ed e‑mail per ricevere un codice di accesso",
  "EmailOtp.nameLabel": "Nome",
  "EmailOtp.namePlaceholder": "Inserisci il tuo nome",
  "EmailOtp.emailLabel": "E‑mail",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "Invia codice",
  "EmailOtp.resendCode": "Reinvia codice",
  "EmailOtp.resendWithCountdown": "Reinvia tra {{s}} s",
  "EmailOtp.codeValidityHint":
    "Il codice è valido per 5 minuti. Non condividerlo con nessuno.",
  "EmailOtp.codeLabel": "Codice di verifica via e‑mail",
  "EmailOtp.codePlaceholder": "Inserisci il codice ricevuto",
  "EmailOtp.signIn": "Accedi",
  "EmailOtp.message.codeSent": "Codice di verifica inviato alla tua e‑mail.",
  "EmailOtp.error.nameRequired": "Il nome è obbligatorio",
  "EmailOtp.error.invalidEmail": "Inserisci un indirizzo e‑mail valido",
  "EmailOtp.error.sendFailed": "Invio del codice non riuscito",
  "EmailOtp.error.codeRequired": "Inserisci il codice di verifica",
  "EmailOtp.error.verificationFailed": "Verifica non riuscita",
  // ===== Academy i18n =====
  "Academy.hero.alert": "Promemoria di sicurezza: verifica sempre i link e non condividere mai la frase di recupero.",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "Accademia",
  "Academy.hero.subtitle": "Guide pratiche su sicurezza crypto, self‑custody e utilizzo del cold wallet LUKKEY.",
  "Academy.search.placeholder": "Cerca tutorial, best practice e FAQ…",
  "Academy.search.hint": "[INVIO]",
  "Academy.card.type.article": "ARTICOLO",
  "Academy.list.title": "Ultime guide",
  "Academy.list.viewAll": "VEDI TUTTO",
  "Academy.list.empty": "Nessun risultato. Prova un'altra parola chiave.",
  "Academy.image.placeholder": "IMMAGINE",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "Torna all’Accademia",
  "AcademyArticle.notFound": "Articolo non trovato",
  "AcademyArticle.author": "Autore",
  "AcademyArticle.unscheduled": "Nessuna data di pubblicazione programmata",
  "home.hero.reserveCtaLabel": "Accesso anticipato — 1 $",
  "home.hero.reserveCtaNote": "Completamente rimborsabile. Nessun impegno all'acquisto."
};
export default translation;
